export default __webpack_public_path__ + "static/media/fail.6260b299.png";